module.exports = __webpack_public_path__ + "img/nishika_white_horizontal.78926664.svg";